export default __webpack_public_path__ + "static/URWDIN-Medium-e33d895ee7c045c533cec275db878779.ttf";